import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import BrandingSettings from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/branding'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'branding_settings_index',
          component: BrandingSettings,
          meta: {
            permissions: [
              'administrator',
              'personalization_manage',
              'personalization_branding_manage',
              'personalization_sidebar_manage',
              'personalization_theme_manage',
            ],
          },
        },
      ],
    },
  ],
};
